import React, { useEffect, useRef, useState } from 'react';
// import { OnboardingHeaderPart } from '../../header/OnboardingHeader';
import HeaderMainPage from '../../header/HeaderMainPage';
import { useNavigate } from 'react-router-dom';
import {
  FaPen,
  FaStar,
  FaBullseye,
  FaMapMarkerAlt,
  FaUsers,
  FaListUl,
  FaFlagCheckered,
  FaChartLine,
  FaCubes,
  FaLightbulb,
} from 'react-icons/fa';
import Swal from 'sweetalert2';
const roboman_api = process.env.REACT_APP_ROBOMAN_API;


const OnboardingReviewCampaign = () => {
  const navigate = useNavigate();
  const [showConstructPopup, setshowConstructPopup] = useState(false);
  const pollingIntervalRef = useRef(null);


  // fetching country code
  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error('Failed to fetch location');
        const data = await response.json();
        const countryCode = data.country_code;
        localStorage.setItem('country_code', countryCode);
      } catch (err) {
        console.error('Fetch error:', err);
        localStorage.setItem('country_code', '');
      }
    };
    fetchCountryCode();
  }, []);


  useEffect(() => {
    setshowConstructPopup(true); // Show the popup when the component is loaded
    console.log('show guidance');
  }, []);

  const handleNotificationConfirm = () => {
    setshowConstructPopup(false);
  };

  useEffect(() => {
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, []);

  const handlePooling = () => {
    if (pollingIntervalRef.current) return;

    const CallPolling = async () => {
      try {
        const campaign_id = localStorage.getItem("campaign_id");
        if (!campaign_id) {
          if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
          }
          return;
        }

        const response = await fetch(
          `${roboman_api}/campaign/check_poll_status/${campaign_id}`,
          {
            headers: {
              accept: "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );

        const statusPayload = await response.json();
        const pollStatus = String(
          statusPayload?.status || statusPayload?.poll_status || ""
        ).toLowerCase();

        if (pollStatus === "done") {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;

          Swal.close();

          await fetch(`${roboman_api}/campaign/delete_poll`, {
            method: "POST",
            headers: {
              accept: "application/json",
              Authorization: localStorage.getItem("access_token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              Campaign_id: campaign_id,
            }),
          });


          navigate("/email-status");
          return;
        }

        if (pollStatus === "failed" || pollStatus === "cancelled") {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Campaign setup stopped",
            text: "Lead fetching did not complete successfully. Please try again.",
          });
        }
      } catch (error) {
        console.error("Polling error:", error);
      }
    };

    CallPolling();
    pollingIntervalRef.current = setInterval(CallPolling, 15000);
  };





  const handleCreateCampaign = async () => {

    const access_token = localStorage.getItem('access_token');
    const unique_selling_proposition =
      localStorage.getItem('select_usp') || localStorage.getItem('unique_selling_proposition');

    const safeJSONParse = (data, fallback) => {
      try {
        return JSON.parse(data);
      } catch {
        return fallback;
      }
    };

    // read buying intent flag from localStorage and normalize to boolean
    const buyingIntentRaw =
      localStorage.getItem('buyingIntent') ?? localStorage.getItem('buying_intent');

    const intent_Status =
      buyingIntentRaw &&
      ['true', '1', 'yes', 'on'].includes(String(buyingIntentRaw).toLowerCase());

    const payload = {
      campaign_name: localStorage.getItem('campaign_name') || '',
      core_service: localStorage.getItem('core_service') || '',
      unique_selling_proposition: unique_selling_proposition || '',
      target_audience: localStorage.getItem('target_audience') || '',
      problem_solved: localStorage.getItem('problem_solved') || '',
      key_benefits: safeJSONParse(localStorage.getItem('key_benefits'), []),
      primary_goal_of_outreach_campaign: localStorage.getItem('primary_goal_of_outreach_campaign') || '',
      ideal_client: safeJSONParse(localStorage.getItem('ideal_client'), []),
      success_measurement: localStorage.getItem('success_measurement') || '',
      must_have_info: localStorage.getItem('campaignMustHaveInfo') || '',
      prospects_count: Number(localStorage.getItem('numberOfCustomers')) || 0,
      email_format: localStorage.getItem('campaignOutputFormat') || '',
      geo_locations: localStorage.getItem('campaignOutputFormat') || '',
      linkedin_msg_format: 'Write a message of 100 words',
      // pass buying intent to backend
      intent_Status,
      geo_locations: localStorage.getItem('geo_locations') || '',
      country_code: localStorage.getItem('country_code') || ''
    };

    try {
      Swal.fire({
        title: 'Creating Campaign...',
        text: 'Please wait while we set things up.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await fetch(`${roboman_api}/campaign/new`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: access_token,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to create campaign: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('Campaign created:', data);
      console.log(data.campaign_id)

      if (data.campaign_id) {
        localStorage.setItem('campaign_id', data.campaign_id);
      }

      handlePooling();


    } catch (error) {
      console.error('Error creating campaign:', error);
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'There was an error creating the campaign. Please try again.',
      });
    }
  };

  const EditPopup = ({ title, content, onCancel, onAccept }) => {
    const [editedContent, setEditedContent] = useState(
      Array.isArray(content) ? content.join('\n') : content
    );

    return (
      <div className="fixed inset-0 z-40 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center px-4">
        <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white/95 shadow-[0_20px_60px_rgba(15,23,42,0.35)]">
          <div className="h-1 w-full bg-gradient-to-r from-[#223F9E] via-indigo-500 to-sky-400 rounded-t-2xl" />
          <div className="px-5 py-4">
            <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
            <p className="text-xs text-slate-500 mb-3">
              Refine this piece of input. Your edits will immediately update the campaign metadata.
            </p>
            <textarea
              className="w-full h-40 px-3 py-2 text-sm border border-slate-200 rounded-xl bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
              value={editedContent}
              onChange={(e) => setEditedContent(e.target.value)}
            />
            <div className="mt-4 flex justify-end gap-2">
              <button
                className="px-4 py-1.5 text-xs font-medium rounded-full border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 transition-all"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                className="px-5 py-1.5 text-xs font-semibold rounded-full bg-gradient-to-r from-[#223F9E] via-indigo-600 to-sky-500 text-white shadow-md hover:brightness-110 transition-all"
                onClick={() => onAccept(title, editedContent)}
              >
                Accept changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Base card component
  const BaseCard = ({ title, label, isHighlight = false, content, onEdit, Icon }) => {
    const hasContent = Array.isArray(content)
      ? content && content.length > 0
      : !!(content && String(content).trim().length > 0);

    const starBg = isHighlight
      ? 'bg-gradient-to-br from-indigo-500 via-violet-500 to-fuchsia-500'
      : 'bg-gradient-to-br from-[#223F9E] via-indigo-500 to-sky-400';
    const labelColor = isHighlight ? 'text-indigo-500' : 'text-slate-400';

    return (
      <div className="w-full min-h-[160px] sm:min-h-[200px] lg:min-h-[220px] rounded-2xl border border-slate-200 bg-white shadow-md flex flex-col overflow-hidden transition-shadow duration-200 hover:shadow-lg">
        <div className="px-4 py-3 flex flex-col gap-3 sm:flex-row sm:items-center  sm:justify-between border-b border-slate-100 bg-white">
          <div className="flex items-center gap-3">
            <div
              className={`w-8 h-8  sm:w-9 sm:h-9 rounded-full ${starBg} flex items-center justify-center text-white shadow-sm`}
            >
              {Icon ? <Icon className=" text-[10px] sm:text-xs" /> : <FaStar className="text-xs" />}
            </div>
            <div className="flex flex-col">
              <span className={`text-[11px] uppercase tracking-wide ${labelColor}`}>{label}</span>
              <span className="text-xs sm:text-sm font-semibold text-slate-900">{title}</span>
            </div>
          </div>
          <div className="flex flex-wrap sm:flex-nowrap items-center gap-2">
            <span
              className={
                'rounded-full px-2 py-0.5 text-[10px] font-medium border ' +
                (hasContent
                  ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
                  : 'bg-amber-50 text-amber-700 border-amber-100')
              }
            >
              {hasContent ? 'Filled' : 'Needs input'}
            </span>
            <button
              onClick={() => onEdit(title, content)}
              className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] text-slate-500 hover:text-indigo-600 hover:border-indigo-200 hover:shadow-sm transition-all"
            >
              <FaPen size={11} className="mr-1" />
              Edit
            </button>
          </div>
        </div>

        <div className="flex-grow px-3 py-2 sm:px-4 sm:py-3 sm:overflow-y-auto">
          {Array.isArray(content) ? (
            <ul className="text-slate-700 text-xs sm:text-sm list-disc pl-4 space-y-1">
              {content.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            <p className="text-slate-700 text-xs sm:text-sm leading-relaxed whitespace-pre-line">
              {content}
            </p>
          )}
        </div>
      </div>
    );
  };

  // Icon chooser
  const getIconForTitle = (title) => {
    switch (title) {
      case 'Core Service/Product':
        return FaCubes;
      case 'Unique Selling Proposition (USP)':
        return FaStar;
      case 'Target Audience':
        return FaBullseye;
      case 'Geographical Locations':
        return FaMapMarkerAlt;
      case 'Problem Solved':
        return FaLightbulb;
      case 'Key Benefits':
        return FaListUl;
      case 'Primary Goal of Outreach Campaign':
        return FaFlagCheckered;
      case 'Ideal Clients':
        return FaUsers;
      case 'Success Measurement':
        return FaChartLine;
      default:
        return FaStar;
    }
  };

  const USPEditPopup = ({ title, usp_user, onCancel, onAccept }) => {
    const [userUSP, setUserUSP] = useState(usp_user);
    const [aiUSP, setAIUSP] = useState(localStorage.getItem('suggest_usp'));

    return (
      <div className="fixed inset-0 z-40 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center px-4">
        <div className="w-full max-w-5xl rounded-2xl border border-slate-200 bg-white/95 shadow-[0_22px_70px_rgba(15,23,42,0.4)]">
          <div className="h-1 w-full bg-gradient-to-r from-emerald-400 via-indigo-500 to-sky-400 rounded-t-2xl" />
          <div className="px-5 py-4">
            <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
            <p className="text-xs text-slate-500 mb-4">
              Compare your original USP with the AI-optimised one. Choose whichever you prefer or
              tweak both before accepting.
            </p>
            <div className="flex flex-col md:flex-row gap-4">
              {/* User USP */}
              <div className="flex-1 rounded-xl border border-slate-200 bg-slate-50/80 p-3">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-sm text-slate-900">User USP</h3>
                  <span className="text-[10px] text-slate-500 uppercase tracking-wide">
                    Original
                  </span>
                </div>
                <textarea
                  className="w-full h-40 px-3 py-2 text-sm border border-slate-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
                  value={userUSP}
                  onChange={(e) => setUserUSP(e.target.value)}
                />
                <div className="mt-3 flex justify-end gap-2">
                  <button
                    className="px-4 py-1.5 text-xs font-medium rounded-full border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 transition-all"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-5 py-1.5 text-xs font-semibold rounded-full bg-gradient-to-r from-[#223F9E] via-indigo-600 to-sky-500 text-white shadow-md hover:brightness-110 transition-all"
                    onClick={() => onAccept(title, userUSP, 'user')}
                  >
                    Accept User USP
                  </button>
                </div>
              </div>

              {/* AI USP */}
              <div className="flex-1 rounded-xl border border-indigo-200 bg-indigo-50/70 p-3">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-sm text-slate-900">USP from AI</h3>
                  <span className="text-[10px] text-indigo-600 uppercase tracking-wide">
                    Suggested
                  </span>
                </div>
                <textarea
                  className="w-full h-40 px-3 py-2 text-sm border border-indigo-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
                  value={aiUSP}
                  onChange={(e) => setAIUSP(e.target.value)}
                />
                <div className="mt-3 flex justify-end gap-2">
                  <button
                    className="px-4 py-1.5 text-xs font-medium rounded-full border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 transition-all"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-5 py-1.5 text-xs font-semibold rounded-full bg-gradient-to-r from-emerald-400 via-green-500 to-emerald-500 text-white shadow-md hover:brightness-110 transition-all"
                    onClick={() => onAccept(title, aiUSP, 'ai')}
                  >
                    Accept AI USP
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ProvidedInfo = () => {
    const [campaignContents, setCampaignContents] = useState({});
    const [editingContent, setEditingContent] = useState(null);
    const [buyingIntentEnabled, setBuyingIntentEnabled] = useState(false);

    useEffect(() => {
      const parseJSONSafely = (item) => {
        try {
          return JSON.parse(item);
        } catch (e) {
          return item;
        }
      };

      localStorage.setItem('selected_usp', localStorage.getItem('unique_selling_proposition'));

      const contents = {
        'Core Service/Product': localStorage.getItem('core_service') || '',
        'Unique Selling Proposition (USP)': localStorage.getItem('selected_usp') || '',
        'Target Audience': localStorage.getItem('target_audience') || '',
        'Geographical Locations': localStorage.getItem('geo_locations') || '',
        'Problem Solved': localStorage.getItem('problem_solved') || '',
        'Key Benefits': parseJSONSafely(localStorage.getItem('key_benefits')),
        'Primary Goal of Outreach Campaign':
          localStorage.getItem('primary_goal_of_outreach_campaign') || '',
        'Ideal Clients': parseJSONSafely(localStorage.getItem('ideal_client')) || '',
        'Success Measurement': parseJSONSafely(localStorage.getItem('success_measurement')),
      };
      setCampaignContents(contents);

      const storedIntent =
        localStorage.getItem('buyingIntent') ?? localStorage.getItem('buying_intent');
      if (storedIntent !== null) {
        const normalized = String(storedIntent).toLowerCase();
        const isEnabled =
          normalized === 'true' ||
          normalized === '1' ||
          normalized === 'yes' ||
          normalized === 'on';
        setBuyingIntentEnabled(isEnabled);
      } else {
        setBuyingIntentEnabled(false);
      }
    }, []);

    const handleEdit = (title, content) => {
      setEditingContent({ title, content });
    };

    const handleCancel = () => {
      setEditingContent(null);
    };

    const handleAccept = (title, newContent, source = null) => {
      setCampaignContents((prev) => ({
        ...prev,
        [title]: Array.isArray(prev[title]) ? newContent.split('\n') : newContent,
      }));
      setEditingContent(null);

      if (title === 'Unique Selling Proposition (USP)') {
        localStorage.setItem('selected_usp', newContent);
      } else if (title === 'Geographical Locations') {
        localStorage.setItem('geo_locations', newContent);
      } else {
        if (Array.isArray(campaignContents[title])) {
          localStorage.setItem(
            title.toLowerCase().replace(/ /g, '_'),
            JSON.stringify(newContent.split('\n'))
          );
        } else {
          localStorage.setItem(title.toLowerCase().replace(/ /g, '_'), newContent);
        }
      }
    };

    // Prepare entries so first 8 are in two columns and last (Key Benefits) is full width
    const entries = Object.entries(campaignContents);
    const keyBenefitsEntry = entries.find(([title]) => title === 'Key Benefits');
    const otherEntries = entries.filter(([title]) => title !== 'Key Benefits');

    return (
      <div className="w-full max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-semibold font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800  bg-clip-text text-transparent ">
            Ready to launch: your campaign, stitched together
          </h2>
          <p className="mt-2 text-sm text-slate-500 max-w-2xl mx-auto">
            Review the key blocks we&apos;ll use to build messaging, targeting and angles. You can
            tweak any card inline before creating the campaign.
          </p>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white/90 shadow-[0_18px_50px_rgba(15,23,42,0.12)] px-4 sm:px-6 md:px-8 py-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center rounded-full bg-slate-900 text-slate-50 text-[11px] font-semibold px-3 py-1">
                Campaign summary
              </span>
              <span className="text-[11px] text-slate-400 hidden sm:inline">
                Snapshot of everything Roboman will use to build this campaign.
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="hidden sm:inline text-[11px] text-slate-400">
                Click <FaPen size={10} className="inline-block mb-[3px]" /> on any card to refine.
              </span>
              <span
                className={
                  'inline-flex items-center rounded-full px-3 py-1 text-[11px] font-semibold border ' +
                  (buyingIntentEnabled
                    ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
                    : 'bg-slate-50 text-slate-500 border-slate-200')
                }
              >
                Buying intent: {buyingIntentEnabled ? 'Enabled' : 'Disabled'}
              </span>
            </div>
          </div>

          {/* Grid: 4 left + 4 right + 1 full width (Key Benefits) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
            {otherEntries.map(([title, content]) => {
              const isUSP = title === 'Unique Selling Proposition (USP)';
              const Icon = getIconForTitle(title);
              return (
                <div key={title}>
                  <BaseCard
                    title={title}
                    content={content}
                    onEdit={handleEdit}
                    isHighlight={isUSP}
                    label={isUSP ? 'Highlight' : 'Campaign input'}
                    Icon={Icon}
                  />
                </div>
              );
            })}

            {keyBenefitsEntry && (() => {
              const [title, content] = keyBenefitsEntry;
              const Icon = getIconForTitle(title);
              return (
                <div key={title} className="md:col-span-2">
                  <BaseCard
                    title={title}
                    content={content}
                    onEdit={handleEdit}
                    isHighlight={false}
                    label="Campaign input"
                    Icon={Icon}
                  />
                </div>
              );
            })()}
          </div>
        </div>

        {editingContent &&
          (editingContent.title === 'Unique Selling Proposition (USP)' ? (
            <USPEditPopup
              title={editingContent.title}
              usp_user={localStorage.getItem('unique_selling_proposition')}
              onCancel={handleCancel}
              onAccept={handleAccept}
            />
          ) : (
            <EditPopup
              title={editingContent.title}
              content={editingContent.content}
              onCancel={handleCancel}
              onAccept={handleAccept}
            />
          ))}
      </div>
    );
  };

  const InformationPart = () => {
    return (
      <div className="flex-grow flex flex-col items-center py-8 px-3 sm:px-4">
        <ProvidedInfo />
      </div>
    );
  };

  const handleNextClick = () => {
    navigate('/new-campaign');
  };

  const Footer = () => {
    return (
      <div className="py-4 bg-white/95 border-t border-slate-200 flex justify-end shadow-[0_-6px_20px_rgba(15,23,42,0.06)]">
        <div className="mb-1 mt-1 mr-6">
          <button
            className="bg-gradient-to-r from-[#223F9E] via-indigo-600 to-violet-500 text-white font-semibold py-2 px-10 rounded-full shadow-md hover:brightness-110 transition-all hover:cursor"
            onClick={handleCreateCampaign}
          >
            Create campaign
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <HeaderMainPage />
      <InformationPart />
      <Footer />

      {showConstructPopup && (
        <div className="fixed inset-0 z-30 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center p-3 sm:p-4 pt-16 sm:pt-0">
          <div className="w-full max-w-2xl sm:max-w-lg md:max-w-2xl rounded-2xl border border-slate-200 bg-white/95 shadow-[0_22px_70px_rgba(15,23,42,0.4)]">
            <div className="h-1 w-full bg-gradient-to-r from-indigo-600 via-indigo-800 to-violet-600 rounded-t-2xl" />
            <div className="px-4 sm:px-6 pt-4 pb-5 max-h-[85vh] overflow-y-auto">
              <h3 className="text-base sm:text-lg  font-semibold font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800  bg-clip-text text-transparent mb-2">
                Optimised Unique Selling Proposition
              </h3>
              <p className="text-sm text-slate-600 mb-4">
                Thank you for assisting us with your campaign details. Based on your inputs, our
                system has generated an{' '}
                <strong className="font-semibold">optimised version of your USP</strong>. You can
                use this as-is or further refine it inside the review cards.
              </p>

              <div className="w-full  mb-4">
                <textarea
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 h-28 sm:h-32 resize-none bg-slate-50 text-sm text-slate-800"
                  value={localStorage.getItem('suggest_usp')}
                  readOnly
                />
              </div>

              <p className="text-sm text-slate-600 mb-5">
                If you want to review and change any information, press the{' '}
                <FaPen size={13} className="inline-block mb-[3px]" /> icon on the corresponding
                card to edit the information before you create the campaign.
              </p>

              <div className="flex justify-center">
                <button
                  className="w-full sm:w-auto px-6 py-3 sm:py-2 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-[#223F9E] via-indigo-600 to-violet-500 shadow-md hover:brightness-110 transition-all"
                  onClick={handleNotificationConfirm}
                >
                  Understand
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingReviewCampaign;
